module.exports = __webpack_public_path__ + "img/b14ba98.png";